import Immutable from 'immutable';
import React from 'react';
import _ from 'underscore';

import ArrowNavigation from '../components/navigation/ArrowNavigation';
import Collapsible from '../components/common/Collapsible';
import Header from '../components/header/Header';
import HeaderWithIcon from '../components/common/HeaderWithIcon';
import OutcomesValueAssessment from '../containers/OutcomesValueAssessment';
import Section from '../components/common/Section';
import TextContent from '../components/common/TextContent';
import styles from '../styles/content.module.styl';

const Facts = ({ location, data, ...props }) => {
  const nodeData = data.allJsonContentsJson.edges[0].node;
  const markerStates = Immutable.fromJS(nodeData.markerStates);
  const processOutcomesExplanation = Immutable.fromJS(nodeData.processOutcomesExplanation);
  const keyFacts = Immutable.fromJS(nodeData.keyFacts);
  const { pageId, groupId, subPage, group } = props.pathContext;

  return (
    <div>
      <Header
        title={nodeData.title}
        group={group}
        location={location}
        logo={nodeData.logo}
        pageId={pageId}
        groupId={groupId}
        subPage={subPage}
      />
      <div className={styles.content}>
        <HeaderWithIcon type="question" title="What should you know?" />
        {keyFacts.map((section, key) => {
          return <Section key={key} section={section} />;
        })}

        <h2 className={styles.sectionTitle}>Explanation of outcomes used in process:</h2>
        {processOutcomesExplanation.map((outcome, index) => {
          const markerState = markerStates.find(markerState => markerState.get('key') === outcome);
          return (
            <Collapsible key={index}>
              <h4>{markerState.get('explanationHeader')}</h4>
              <TextContent content={markerState.get('content')} />
            </Collapsible>
          );
        })}
        <HeaderWithIcon type="assessment" title="Assess your values" />
        <TextContent content="To calculate an individual recommendation and to help understand how good or bad a health state is we have created the scales below with &quot;dead&quot; marked as 0 and &quot;good health&quot; marked as 100. We would like you to indicate on these scales how good or bad each health state is in your opinion:" />
        <OutcomesValueAssessment outcomes={markerStates.filter(ms => ms.get('marker'))} />
        <ArrowNavigation prevLink={`/${pageId}`} nextLink={`/${pageId}/${groupId}/options`} />
      </div>
    </div>
  );
};

export default Facts;

export const query = graphql`
  query FactsQuery($pageId: String) {
    allJsonContentsJson(filter: { pageId: { eq: $pageId } }) {
      edges {
        node {
          logo
          groups {
            name
            title
          }
          keyFacts {
            title
            content
            image {
              src
              position
            }
          }
          processOutcomesExplanation
          markerStates {
            key
            marker
            markerPrefix
            explanationHeader
            content
            summaryTitle
            forIntervention
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/facts-template.js